import { combineReducers } from 'redux'
import { reducer as proceedToOrdinaryProduct } from './validate-permission/reducer'

export const reducer = combineReducers({
  proceedToOrdinaryProduct,
})
